import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work2MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import BackButton from './components/BackButton';
import NextItem from './components/NextItem';
import thumbnail3 from './image/workThumbnails/thumbnail3.webp';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';
//FirstUserProcessDesign

function Work2(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'First User Process Design - Lynkim',
      description: 'Onboarding process design on bookcovery to make activation.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'First User Process Design'} 
          description={'Onboarding process design on bookcovery to make activation.'} 
          team={'Bookcovery'} 
          role={'Service Planning, UXUI Design'} 
          period={'2020.05 - 2020.11.'}
          titleKo={'첫 사용자 온보딩 프로세스 설계'}
          descriptionKo={'북커버리 활성화를 위한 온보딩 프로세스를 설계했습니다.'}
          teamKo={'북커버리(Bookcovery)'}
          roleKo={'서비스 기획, UXUI 디자인'}
          showButton={true}
          buttonLabel="View Project"
          buttonHref="https://www.figma.com/proto/iQ9Tgs7kQgjO6waM0oealt/Portfolio_lynkim?page-id=4%3A44&node-id=318-18560&viewport=710%2C971%2C0.16&t=3pOCsjuWLsdn124f-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=318%3A18560"/>
      </div>
      <MainImage image={mainImage}/>
      {/* <Waiting/> */}
      <BackButton/>
      <div style={{ height: "400px" }} />
      
      <NextItem to='/Work3' thumbnail={thumbnail3} nextProjectTitle='Store UX/UI Design'/>
      </>
      // </ProtectedPage>
    )
}

export default Work2;
